<template>
    <ul class="hz-chat-from" id="hz-chat-from">
        <li class="other chat-items">
            <div class="other-img avator"></div>
            <span class="other-text text-style">

                 {{multyLang&&multyLang[currentConfig.welcomeText]?multyLang[currentConfig.welcomeText][currentTranslateCode]:'welcome'}}
            </span>
        </li>
        <li class="other chat-items">
            <template>
                <img class="other-img avator" :src="avatorSrc" alt="">
            </template>
            <div class="other-form">
                <template v-if="!hasSubmit">
                    <p class="form-des">
                        {{multyLang&&multyLang[currentConfig.formIntro]?multyLang[currentConfig.formIntro][currentTranslateCode]:''}}
                    </p>
                    <p class="form-mark">
                        {{multyLang&&multyLang[currentConfig.formValidDes]?multyLang[currentConfig.formValidDes][currentTranslateCode]:''}}
                    </p>
                    <div :model="currentForms" ref="createForm" label-width="0px"
                         class="el-form create-field--forms">
                        <div class="el-form-item"
                             style="position: relative"
                             v-for="(item,index) in offLineForm"
                             :prop="item.key"
                             :rule="computedRules(item)"
                        >
                            <div v-if="item.type=='custom'&&item.list.length>0">
                                <ul class="chooseItem">
                                    <p class="choose-title">Select a required item</p>
                                    <el-radio-group v-model="radio">
                                        <li class="choose-input" v-for="(i,j) in item.list">
                                            <el-radio :label="i.key">
                                                <create-form :item="i" @changRadio="changRadio" :currentform="customForm"
                                                             v-model="customForm[i.key]" :isCustom="true"></create-form>
                                            </el-radio>
                                        </li>
                                    </el-radio-group>
                                </ul>
                            </div>

                            <create-form v-else :item="item" v-model="currentForms[item.key]"
                                         :currentform="currentForms"></create-form>
                        </div>
                    </div>
                    <div class="form-submit" @click="conversionTriggerFn">
                        <hz-button type="primary" :loading="loading" id="hz_sub_btn" size="mini" @click="submitForm"
                                   class="el-button sub-btn el-button--primary el-button--mini"
                                   :style="{backgroundColor:currentConfig.submitBtnColor}">{{multyLang&&multyLang[currentConfig.submitBtnText]?multyLang[currentConfig.submitBtnText][currentTranslateCode]:'submit'}}
                        </hz-button>
                    </div>
                </template>

                <template v-if="hasSubmit">
                    <div  class="has-submit">
                        <div class="has-submit-box">
                            <div class="has-submit-item">
                                <i class="icon hz-icon-form-img-sucess"></i>
                                <p>{{multyLang&&multyLang['成功']?multyLang['成功'][currentTranslateCode]:'success'}}</p>
                                <p>{{multyLang&&multyLang['您的表单已提交']?multyLang['您的表单已提交'][currentTranslateCode]:'Your form has been submitted'}}</p>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </li>
    </ul>

</template>

<script>
    import {baseChatUrl, baseUrl_1, baseUrl_8} from "../config/env";
    import CreateForm from "./createForm";
    import AsyncValidator from 'async-validator'
    import {store,mutations} from "../store";
    import HzButton from "./button";
    import {creatConversionDiv} from "@/util/util";
    export default {
        name: 'chatForm',
        components: {
            CreateForm,
            HzButton
        },
        props: {
            avatorSrc:{
                type:String,
                default:''
            },
            item:{
                type:Object,
                default(){
                    return {}
                }
            }

        },
        computed:{
            currentTranslateCode(){
                return store.currentTranslateCode
            },
            multyLang(){
                return store.multyLang
            },
            currentConfig(){
                return store.offlineConfig
            },
            offLineForm(){
              console.log('检查 offLineForm 的数据结构', store.offLineForm);
                return store.offLineForm
            },
            offlineFormId(){
                return store.offlineFormId
            },
            conversionConfigId() {
              return store.conversionConfigId;
            },
        },
        data() {
            return {
                radio: 3,
                currentForms: {},
                rules: {},
                customForm: {},
                currentValidIndex: 0,
                validArr: [],
                customRules: {},
                element: null,
                hasSubmit:false,
                loading:false,
                hasSubmitLeaveForm:false
            }
        },
        created() {
            let _this = this;
            this.getCluesField(_this.offLineForm, _this.currentForms);
        },
        mounted() {
            let ele = document.getElementById('hzchat-list-box');
            if (ele) {
                setTimeout(()=>{
                    ele.scrollTop = ele.scrollHeight;
                },500)

            }
        },
        methods: {
            conversionTriggerFn() {
              if(this.conversionConfigId == 3 || this.conversionConfigId == 4) {
                creatConversionDiv();
              }
            },
            computedRules(item) {
                let arr = [];
              // 获取错误提示信息
                let message = this.multyLang[item.placeholder]&&this.multyLang[item.placeholder][this.currentTranslateCode]?this.multyLang[item.placeholder][this.currentTranslateCode]:'please input'
              // 1. 必填校验
                if (item.required == 1 || item.required) {
                  // 文本类型使用 blur 触发
                    if (item.type == 'text') {
                        let requireObj = {required: true, message: message, trigger: 'blur'};
                        arr.push(requireObj);
                    } else {
                      // 其他类型使用 change 触发
                        let requireObj = {required: true, message: message, trigger: 'change'};
                        arr.push(requireObj);
                    }
                }
              // 2. 自定义校验规则
                if (item.hasOwnProperty('validate') && item.validate && item.validate.rule.length > 0) {
                    arr.concat(item.validate.rule)
                }
                if (item.hasOwnProperty('key') && !this.rules[item.key]) {
                    this.rules[item.key] = arr;
                }
                if (item.type == 'custom' && item.list.length > 0) {
                    item.list.forEach((i, j) => {
                        let brr = []
                        if (i.hasOwnProperty('validate') && i.validate && i.validate.rule.length > 0) {
                            brr.concat(i.validate.rule);
                            customRules[i.key] = [].concat(brr);
                        }
                    })

                }
              // 3. 邮箱格式校验
                if(item.key === 'm_email'){
                  // alert("判断邮箱格式m_email")
                    this.rules[item.key].push({
                        type: 'email',
                        message: this.multyLang&&this.multyLang['邮箱格式不正确']?this.multyLang['邮箱格式不正确'][this.currentTranslateCode]:'Please enter the correct email address',
                        trigger: 'blur,change'
                    })
                }
                if(item.key === 'email'){
                  // alert("判断邮箱格式email")
                    this.rules[item.key].push({
                        type: 'email',
                        message: this.multyLang&&this.multyLang['邮箱格式不正确']?this.multyLang['邮箱格式不正确'][this.currentTranslateCode]:'Please enter the correct email address',
                        trigger: 'blur,change'
                    })
                }
                // 添加电话号码验证
                if(item.key === 'phone' || item.key === 'm_phone' ){
                    this.rules[item.key].push({
                        pattern: /^(?:\+?\d{1,3}[-.\s]?)?(?:\(?\d{1,4}\)?[-.\s]?)?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,4}$/,  // 手机号格式
                        message: this.multyLang&&this.multyLang['手机号格式不正确']?this.multyLang['手机号格式不正确'][this.currentTranslateCode]:'Please enter the correct phone number',
                        trigger: 'blur,change'
                    })
                }

                console.info('rules', this.rules);

                return arr
            },

          getCluesField(list, obj) {
                let _this = this;
                list.forEach((item, index) => {
                    if (!obj[item.key]) {
                        if (item.type == 'multipleText') {
                            obj[item.key] = [''];
                        } else if (item.type == 'multipleSelect') {
                            obj[item.key] = [{
                                key: "",
                                value: ""
                            }]
                        } else if (item.type == 'custom') {
                            _this.getCluesField(item.list, _this.customForm)

                        }else if(item.type == 'checkbox'){
                            obj[item.key] = ''
                        } else {
                            obj[item.key] = ''
                        }
                    }
                })
                obj = Object.assign({}, obj);
                console.info('obj', obj);
            },

            addOptions(key, flag) {
                if (flag == 'select') {
                    this.currentForms[key].push({
                        key: '',
                        value: ''
                    })
                } else {
                    this.currentForms[key].push('')
                }

            },
            removeOptions(key, index) {
                this.currentForms[key].splice(index, 1);
            },
            submitForm() {
                let _this = this;
                this.currentValidIndex = 0;
                this.valiaField();
                let params = Object.assign({}, _this.currentForms, {
                    companyId:utilConfig.enterpriseId,
                    messagePage: window.location.href,
                    formId: _this.offlineFormId,
                    serverId: window.utilConfig.serverId,
                    [_this.radio]: this.customForm[_this.radio]
                })
                let customForm =  this.customForm;
                for(var i in customForm){
                    if(customForm[i]){
                        params[i] = customForm[i]
                    }
                }


                this.validate(() => {
                    _this.offLineForm.forEach((item,index)=>{    //转成时期格式，方便筛选
                        if(item.type=='date'||item.type=='datetime'){
                            if(params[item.key].length>0){
                                params[item.key] = new Date(Number(params[item.key]))
                            }
                        }
                    })
                    _this.loading = true;
                    hzAjax({
                        url:baseUrl_8 + '/message/' + utilConfig.visitorid,
                        type: "PUT",
                        contentType:"application/json",
                        data: JSON.stringify(params),
                        success:function (res) {
                            _this.loading = false;
                            if (res.code == _this.$successCode) {
                                try{
                                    _this.$message(_this.multyLang['提交成功'][_this.currentTranslateCode], 'success');

                                }catch (e) {
                                    _this.$message("success")
                                }
                                _this.hasSubmit = true;
                                store.hasSubOnlineForm = true;
                                mutations.SubOnlineForm();
                            }else{
                                _this.$message(res.info);
                            }
                        }
                    })

                })
            },

            valiaField() {
                this.validArr = [];
                let _this = this;
                this.offLineForm.forEach((item, index) => {
                    // if ((item.required == 1 || item.hasOwnProperty('key') && !this.rules[item.key].length > 0) && item.type != 'custom') {   //需要校验
                    if (item.hasOwnProperty('key') && this.rules[item.key] && this.rules[item.key].length > 0 && item.type != 'custom') {  //需要校验
                        if (item.type == 'multipleText' || item.type == 'multipleSelect') {
                            for (var i = 0; i < _this.currentForms[item.key].length; i++) {
                                this.validArr.push({
                                    prop: item.key + '[' + i + ']',
                                    obj: item,
                                    key: item.key,
                                    value: _this.currentForms[item.key][i]
                                })
                              console.log("this.validArr111", this.validArr);
                            }

                        } else {
                            if (item.type !== 'custom') {
                                this.validArr.push({
                                    prop: item.key,
                                    key: item.key,
                                    value: _this.currentForms[item.key]
                                })
                              console.log("this.validArr222", this.validArr);
                            }
                        }
                    } else if (item.type == 'custom') {
                        // 自定义的先不做校验
                        this.validArr.push({
                            prop: 'custom666',
                            key: 'custom666',
                            data: item.list||[],
                            value: _this.customForm
                        })
                      console.log("this.validArr333", this.validArr);
                    }
                })
                console.info('validArr', this.validArr)

            },
            validate(callback) {
                let _this = this;
              console.log("_this.currentValidIndex", _this.currentValidIndex);
              if (_this.currentValidIndex >= _this.validArr.length) {
                if (typeof callback === 'function') callback();
                return;
              }
              console.log("currentItem", _this.currentValidIndex);
                let currentItem = _this.validArr[_this.currentValidIndex];
              console.log("_this.validArr", _this.validArr);
                if (currentItem.key != 'custom666') {
                    let ruleItem = _this.rules[currentItem.key];
                    let formRules = {};
                    if (ruleItem.length > 0) {
                        formRules[currentItem.prop] = ruleItem;
                        const validator = new AsyncValidator(formRules);
                        validator.validate({[currentItem.prop]: currentItem.value}, (errors, fields) => {
                            if (errors) {
                                _this.$message(errors[0].message);
                            } else {
                                if (_this.currentValidIndex < _this.offLineForm.length - 1) {
                                    _this.currentValidIndex++;
                                    _this.validate(callback);
                                } else {
                                    typeof callback == 'function' && callback()
                                }
                            }
                        })
                    } else {
                        if (_this.currentValidIndex < _this.offLineForm.length - 1) {
                            _this.currentValidIndex++;
                            _this.validate(callback);
                        } else {
                            typeof callback == 'function' && callback()
                        }
                    }
                } else {
                    if (currentItem.data.length == 0) {
                        if (_this.currentValidIndex < _this.offLineForm.length - 1) {
                            _this.currentValidIndex++;
                            _this.validate(callback);
                        } else {
                            typeof callback == 'function' && callback()
                        }
                    } else {
                        let flag = false;
                        for (var i in currentItem.value) {
                            if (currentItem.value[i].length > 0) {
                                flag = true
                            }
                        }
                        if (flag) {
                            if (_this.currentValidIndex < _this.offLineForm.length - 1) {
                                _this.currentValidIndex++;
                                _this.validate(callback);
                            } else {
                                typeof callback == 'function' && callback()
                            }
                        } else {
                            try {
                                _this.$message(_this.multyLang["任选一项需要填写"][_this.currentTranslateCode]);
                            }catch (e) {
                                _this.$message('Please select any item to fill in')
                            }

                        }
                    }
                }
            },
            changRadio(val) {
                this.radio = val;
            },
        }
    }
</script>



<style lang="scss">
    #hz_chat_app{
        .hz-chat-from {
            padding: 16px 0;
            overflow: hidden;
            width: 100%;
            /*padding-left: 1px;*/
            .chat-items {
                margin: 0 auto;
                margin-bottom: 16px;
                text-align: left;
            }

            .text-style {
                background: #E6EAF2;
                box-shadow: none;
                margin-left: 8px;
            }

            .other-form {
                /*float: right;*/
                width: 300px;
                height: auto;
                background: #fff;
                border-radius: 3px;
                border: 1px solid #E9E9E9;
                display: inline-block;
                margin-left: 8px;
                transition: all 0.28s;
                -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5);
                box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5);
                position: relative;
                &:hover{
                    -webkit-box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5);
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5);
                }

                .has-submit{
		    /*position: absolute;*/
                    /*top:0px;*/
                    /*bottom: 0px;*/
                    /*left: 0px;*/
                    /*right: 0px;*/
                    background: #fff;
                    text-align: center;
                    height: 270px;
                    .has-submit-box{
                        height: 100%;
                        width: 100%;
                        display: table;
                        .has-submit-item{
                            vertical-align: middle;
                            display: table-cell;
                            text-align: center;
                            color: #606266;
                        }
                        .hz-icon-form-img-sucess{
                            font-size: 60px;
                            color: #2FC25B;
                            display: block;
                            margin-bottom: 50px;
                            margin-top: -40px;
                        }
                        p{
                           line-height: 26px;
                        }
                    }

                }
            }

            .form-des {
                width: 268px;
                font-size: 14px;
                font-family: SFUIText-Regular, SFUIText;
                font-weight: 400;
                color: rgba(3, 15, 30, 1);
                line-height: 20px;
                margin: 11px auto;
            }

            .form-mark {
                width: 268px;
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFangSC;
                font-weight: 400;
                color: rgba(3, 15, 30, 1);
                line-height: 20px;
                text-align: left;
                margin: 0 auto;
                color: #EC7775;
            }

            /*.form-item {*/
                /*margin: 0 auto;*/
                /*border-radius: 4px;*/
                /*width: 268px;*/
                /*!*box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.1);*!*/
            /*}*/

            /*.custom-input {*/
                /*width: 262px;*/
                /*height: 40px;*/
                /*background: rgba(255, 255, 255, 1);*/
                /*box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.1);*/
                /*border-radius: 4px;*/
                /*border: 1px solid rgba(217, 217, 217, 1);*/
                /*padding: 0px 5px;*/
            /*}*/

            /*.must-input {*/
                /*margin: 8px auto 12px;*/
                /*text-align: center;*/
                /*position: relative;*/

            /*}*/

            /*.must-input .custom-input {*/
                /*padding-left: 15px;*/
            /*}*/

            /*.must-input:after {*/
                /*position: absolute;*/
                /*right: 10px;*/
                /*top: 0;*/
                /*content: '*';*/
                /*color: #FF4D4F;*/
                /*font-size: 30px;*/
                /*display: inline-block;*/
                /*height: 40px;*/
                /*width: 40px;*/
                /*line-height: 51px;*/
                /*margin-left: 1px;*/
                /*vertical-align: top;*/

            /*}*/

            .choose-input {
                width: 266px;
                /*height: 42px;*/
                background: rgba(255, 255, 255, 1);
                /*box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.1);*/
                border-radius: 4px;
                border: 1px solid rgba(217, 217, 217, 1);
                /*margin: 0 auto;*/
                margin-bottom: 8px;
            }

            /*.choose-input .el-radio__label {*/
                /*display: none;*/
            /*}*/

            .choose-input input {
                /*height: 40px;*/
                /*!*line-height: 40px;*!*/
                /*border: none;*/
                /*outline: none;*/
                /*vertical-align: top;*/
            }

            .chooseItem {
                width: 300px;
                padding: 2px 0 8px;
                background: rgba(216, 216, 216, 0.5);
                margin-bottom: 10px;
                padding-left: 17px;
            }

            .choose-title {
                width: 268px;
                font-size: 14px;
                font-family: SFUIText-Regular, SFUIText;
                font-weight: 400;
                color: rgba(3, 15, 30, 1);
                line-height: 20px;
                margin: 11px auto;
            }

            .form-submit {
                width: 262px;
                margin: 0 auto;
                text-align: right;
                padding-bottom: 12px;
            }

            .sub-btn {
                background: #428BCA !important;
                padding-left: 20px;
                padding-right: 20px;
            }
        }
    }


</style>
<style>
    .el-popper {
        z-index: 99999999 !important;
    }
    .create-field--forms {
        margin-top: 12px;
    }

    .create-field--forms .el-form-item {
        margin-bottom: 0px;
        /*height: 50px;*/
    }
    .choose-input .el-radio__input {
        vertical-align: top;
        margin-left: 10px;
        height: 40px;
        line-height: 40px;

    }

    .other-form .el-radio-group {
        margin: 0 auto;
        display: block;
    }

</style>
